import React from 'react';
import { Divider } from '@kambi/spark';

import classes from './Description.module.css';

const Description = () => {
  const { DescriptionItem } = classes;
  return (
    <div>
      <p className={DescriptionItem}>
        <strong>Kambi Betting Client Helpers</strong> is an npm package that
        offers some utilities that can help you build your own betting client
        UI, like: outcome label, betoffer label, odds utils, etc. We expose them
        as methods that can receive some parameters and based on them we do the
        parse them and return the formated data.
      </p>
      <Divider />
      <p className={DescriptionItem}>
        <b>Download link:</b>{' '}
        <a
          href='https://www.npmjs.com/package/@kambi/betting-client-helpers'
          target='_blank'
          rel='noreferrer'
        >
          https://www.npmjs.com/package/@kambi/betting-client-helpers
        </a>
      </p>
      <p className={DescriptionItem}>
        <b>Install it:</b> npm install @kambi/betting-client-helpers
      </p>
      <div className={DescriptionItem}>
        <b>Use it:</b>
        <ol>
          <li>
            Import the helper method in your js file:{' '}
            <i>
              import {'{outcomeLabel}'} from "@kambi/betting-client-helpers"
            </i>
          </li>
          <li>
            Invoke the method <i>outcomeLabel(args)</i>, see the links bellow
            for more info about the arguments that each helper can receive.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default Description;
